// Chatwoot canli destek widget'i.
// SDK lazy yuklenir: ilk "Destek AI" tiklamasina kadar Chatwoot'a hicbir
// istek atilmaz. Chatwoot tum kullanicilari tek IP olarak gordugu icin
// (private ag / proxy arkasi) her gereksiz istek ortak rate-limit kotasini
// tuketir. Basarisiz yukleme denemesi loader'i sifirlar; buton bir sonraki
// tiklamada yeniden dener, sayfa yenilemeye gerek kalmaz.

declare global {
  interface Window {
    chatwootSettings: Record<string, unknown>;
    chatwootSDK?: { run: (options: { websiteToken: string; baseUrl: string }) => void };
    $chatwoot?: { toggle: (state?: "open" | "close") => void };
  }
}

// Her iki deger de .env'den gelir (git'e girmez, sunucuda elle tanimlanir).
// DIKKAT: VUE_APP_* degiskenleri BUILD aninda bundle'a gomulur, runtime'da
// okunmaz. Yani .env sunucuda "npm run build" calismadan ONCE hazir olmali;
// sonradan eklenirse yeniden build gerekir.
const BASE_URL: string = process.env.VUE_APP_CHATWOOT_BASE_URL || "";
const WEBSITE_TOKEN: string = process.env.VUE_APP_CHATWOOT_TOKEN || "";

const READY_TIMEOUT_MS = 15000;

// DEV-3548: Sekme arka plandayken gelen cevabi duyuran ORTAK dosya.
//
// Kullanici mesaji yazip baska sekmeye geciyor ve cevabi kaciriyordu. Chatwoot'un
// kendi ses mekanizmasi bu kurulumda calismaz: ses kilidini acan dinleyicilerini
// SDK yuklendiginde kuruyor, oysa kilidi acabilecek tek jest ("Destek AI"
// tiklamasi) bundan ONCE gerceklesiyor; sonrasinda kullanici iframe'in icine
// yazdigi icin tus vuruslari parent document'a hic ulasmiyor. Ayrica Chatwoot
// sesi yalnizca insan temsilci cevabinda calar, bot cevaplarinda calmaz.
//
// SDK ile BIRLIKTE DEGIL, modul yuklenirken enjekte ediliyor. Sebebi tam olarak
// yukaridaki hata: ortak dosya kendi jest dinleyicilerini yuklendigi anda
// kuruyor. loadChatwoot icine konsaydi dinleyiciler "Destek AI" tiklamasindan
// SONRA kurulur ve ilk cevapta ses yine calmazdi.
//
// Mantik BES URUNDE ORTAK tek dosyada; degisiklik dashboard'a deploy edilince
// hepsi guncellenir, bu repoya tekrar dokunulmaz. Dosya `window` uzerinde
// "chatwoot:on-message" dinledigi icin SDK'nin ne zaman yuklendigi onemli degil.
//
// ?v= ZORUNLU: Cloudflare tarayici cache'ini 4 saate cekiyor ve origin'deki kisa
// sureyi gecersiz kiliyor. Ortak dosya guncellendikce bu numara artirilmali.
const NOTIFY_SCRIPT_ID = "chat-notify";
const NOTIFY_SCRIPT_SRC = "https://dashboard.icrapro.com/chat-notify.js?v=1";

function injectChatNotify(): void {
  if (document.getElementById(NOTIFY_SCRIPT_ID)) {
    return;
  }
  const script = document.createElement("script");
  script.id = NOTIFY_SCRIPT_ID;
  script.src = NOTIFY_SCRIPT_SRC;
  script.defer = true;
  // Bildirim ikincil bir ozellik: yuklenemezse sohbet calismaya devam etmeli.
  script.onerror = () => {
    // eslint-disable-next-line no-console
    console.warn("Sohbet bildirim dosyasi yuklenemedi:", NOTIFY_SCRIPT_SRC);
  };
  document.head.appendChild(script);
}

injectChatNotify();

let loader: Promise<void> | null = null;

function loadChatwoot(): Promise<void> {
  if (loader) {
    return loader;
  }

  if (!WEBSITE_TOKEN || !BASE_URL) {
    console.warn(
      "[chatwoot] Destek widget'i yuklenmedi: " +
        (!BASE_URL ? "VUE_APP_CHATWOOT_BASE_URL " : "") +
        (!WEBSITE_TOKEN ? "VUE_APP_CHATWOOT_TOKEN " : "") +
        "build sirasinda tanimli degildi. Sunucudaki .env dosyasina ekleyip yeniden build alin."
    );
    return Promise.resolve();
  }

  window.chatwootSettings = {
    position: "right",
    type: "standard",
    launcherTitle: "Destek",
    hideMessageBubble: true,
  };

  loader = new Promise<void>((resolve, reject) => {
    if (window.$chatwoot) {
      resolve();
      return;
    }

    // Basarisizlikta loader sifirlanir: buton sonraki tiklamada yeniden dener.
    const fail = (err: Error) => {
      window.clearTimeout(timeoutId);
      loader = null;
      reject(err);
    };

    const timeoutId = window.setTimeout(() => {
      fail(new Error("Chatwoot widget " + READY_TIMEOUT_MS + "ms icinde hazir olmadi (sunucu rate limit olabilir)."));
    }, READY_TIMEOUT_MS);

    // SDK hazir oldugunda $chatwoot erisilebilir olur; run() cagrisi tek basina yetmez.
    window.addEventListener(
      "chatwoot:ready",
      () => {
        window.clearTimeout(timeoutId);
        resolve();
      },
      { once: true }
    );
    window.addEventListener(
      "chatwoot:error",
      () => fail(new Error("Chatwoot widget baslatilamadi (chatwoot:error).")),
      { once: true }
    );

    const script = document.createElement("script");
    script.src = BASE_URL + "/packs/js/sdk.js";
    script.defer = true;
    script.async = true;
    script.onload = () => {
      if (!window.chatwootSDK) {
        fail(new Error("Chatwoot SDK yuklendi ama chatwootSDK bulunamadi."));
        return;
      }
      window.chatwootSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: BASE_URL });
    };
    script.onerror = () => fail(new Error("Chatwoot SDK yuklenemedi: " + script.src));
    document.head.appendChild(script);
  });

  return loader;
}

export function openChatwoot(): Promise<void> {
  return loadChatwoot().then(() => {
    if (window.$chatwoot) {
      window.$chatwoot.toggle("open");
    }
  });
}
